import { createAction } from '@reduxjs/toolkit';

export const requestCreateResource = createAction('request/createResource');
export const requestUpdateResource = createAction('request/updateResource');
export const requestDeleteResource = createAction('request/deleteResource');
export const requestViewResourcesByType = createAction('request/viewResourcesByType');
